export default __webpack_public_path__ + "static/media/disposal.c39c6c45.svg";